var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1013_20692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60225 18.5119C5.35453 18.5119 4.15791 18.0378 3.27563 17.1939C2.39336 16.35 1.89771 15.2054 1.89771 14.0119C1.89771 12.8184 2.39336 11.6738 3.27563 10.8299C4.15791 9.98602 5.35453 9.51191 6.60225 9.51191C6.89694 8.19909 7.75901 7.0454 8.99884 6.30463C9.61274 5.93784 10.3009 5.68346 11.024 5.55603C11.7472 5.42859 12.4911 5.43059 13.2134 5.56191C13.9356 5.69324 14.6221 5.95131 15.2335 6.32139C15.845 6.69148 16.3695 7.16633 16.777 7.71884C17.1846 8.27135 17.4672 8.89069 17.6088 9.54151C17.7504 10.1923 17.7482 10.8619 17.6023 11.5119H18.6023C19.5305 11.5119 20.4207 11.8807 21.0771 12.537C21.7335 13.1934 22.1023 14.0837 22.1023 15.0119C22.1023 15.9402 21.7335 16.8304 21.0771 17.4868C20.4207 18.1432 19.5305 18.5119 18.6023 18.5119H17.6023",
    stroke: "#484848",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5117L12 12.5117L15 15.5117",
    stroke: "#484848",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5117V21.5117",
    stroke: "#484848",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1013_20692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.511719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloudUpload.d3eba9b691fb1a21db91cbaf2161c752.svg";
export { ForwardRef as ReactComponent };